import './scss/critical-s-utah.scss';
import './scss/style-s-utah.scss';
import './js/fe-core.js';
import FeCore from './js/fe-core.js';
import Ski_Beginner_V01 from './images/Ski_Beginner_V01.mp4';
import Ski_Expert_V01 from './images/Ski_Expert_V01.mp4';
import Ski_Family_V01 from './images/Ski_Family_V01.mp4';
import Ski_Fun_V01 from './images/Ski_Fun_V01.mp4';
import Ski_Intermediate_V01 from './images/Ski_Intermediate_V01.mp4';
import Ski_MainLanding_V01 from './images/Ski_MainLanding_V01.mp4';

const feCore = new FeCore();